import { Component } from "@angular/core";

@Component({
  selector: "spinner-loader",
  templateUrl: "./spinner-loader.component.html",
  styleUrls: ["./spinner-loader.component.css"]
})
export class SpinnerLoader {}
